// src/utils/memory.js — passive memory detection from state
// Detects facts worth storing as memories, surfaces them for user confirmation

const TODAY = new Date().toISOString().slice(0, 10);

/**
 * Scans current state and derives memory candidates from structured data.
 * Returns array of {cat, text, key} objects not yet in st.memories.
 */
export function detectMemories(st) {
  const candidates = [];
  const existing = new Set((st.memories || []).map(m => m.key));

  // Race from dedicated fields
  if (st.raceName && st.raceDate && !existing.has('race_' + st.raceName.replace(/\s+/g,'_').toLowerCase())) {
    const days = Math.ceil((new Date(st.raceDate+'T12:00:00') - new Date()) / 86400000);
    if (days >= 0 && days <= 365) {
      candidates.push({
        cat: 'fitness',
        text: `Training for ${st.raceName} on ${st.raceDate} (${days} days away)`,
        key: 'race_' + st.raceName.replace(/\s+/g,'_').toLowerCase().slice(0,20),
      });
    }
  }

  // Weekly mileage goal from profile
  if (st.profile?.weeklyMileageGoal && !existing.has('weekly_mileage_goal')) {
    candidates.push({
      cat: 'fitness',
      text: `Weekly running mileage goal is ${st.profile.weeklyMileageGoal} miles`,
      key: 'weekly_mileage_goal',
    });
  }

  // Work schedule
  if (st.profile?.workType && !existing.has('work_schedule')) {
    candidates.push({
      cat: 'work',
      text: `Works ${st.profile.workType} schedule`,
      key: 'work_schedule',
    });
  }

  // Vinyl collection size
  const collectionSize = (st.vinyl || []).filter(v => v.status === 'collection').length;
  if (collectionSize >= 10 && !existing.has('vinyl_collection_size')) {
    candidates.push({
      cat: 'vinyl',
      text: `Has a vinyl collection of approximately ${collectionSize} records`,
      key: 'vinyl_collection_size',
    });
  }

  // Active goals
  const activeGoals = (st.goals || []).filter(g => !g.archived && g.title);
  if (activeGoals.length > 0 && !existing.has('active_goals_summary')) {
    candidates.push({
      cat: 'personal',
      text: `Active goals: ${activeGoals.slice(0,3).map(g=>g.title).join(', ')}`,
      key: 'active_goals_summary',
    });
  }

  return candidates.slice(0, 2); // surface max 2 at once
}
